import { createContext, useContext, useReducer } from 'react';

import { initialState, reducer } from '../reducers/actionReducer';

const ActionModalContext = createContext();

export function ActionModalProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = {
    state,
    dispatch,
  };

  return (
    <ActionModalContext.Provider value={value}>
      {children}
    </ActionModalContext.Provider>
  );
}

export function useActionModal() {
  const context = useContext(ActionModalContext);
  if (!context) {
    throw new Error(
      'useActionModal must be used within an ActionModalProvider'
    );
  }
  return context;
}
